/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-15 13:46:42
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 20:19:46
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Space, Tabs } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootDispatch } from '../../app/store'
import { TabPane } from '../../compnents/widgets/TabBar'
import { selectMenus } from '../../layouts/layoutSlice'
import styles from './personalManagement.module.css'
import { PersonalSetting } from './personalSetting/personalSetting'
import { PersonalDetail } from './personalDetail/personalDetail'
import { OtherSettings } from './personalSetting/otherSettings'
import { MedicalSettings } from './personalSetting/medicalSettings'
import { SquareRootSetting } from './personalSetting/squareRootSetting'
import { useQuery } from '../../utils/HttpUtils'
import { selectTenantCategory } from '../../app/applicationSlice'

export const PersonalSettingsTabs = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const query = useQuery()

  const id = query.get('id')

  const tenantCategory = useSelector(selectTenantCategory)

  const [selectedTab, setSelectedTab] = useState<any>(1)

  useEffect(() => {
    setSelectedTab(id ? 2 : 1)
  }, [id])

  return (
    <Col className={styles.contentMain}>
      <Tabs
        tabPosition={'left'}
        onChange={(v) => {
          setSelectedTab(v)
        }}
      >
        {id ? <></> :
          <TabPane key='1' tab='基本信息'>
            <PersonalDetail selectedTab={selectedTab} />
          </TabPane>}
        {/* tenantCategory == 1 药店 */}
        {tenantCategory == 1 ? <></> :
          <>
            <TabPane key='2' tab='病历设置'>
              <MedicalSettings selectedTab={selectedTab} />
            </TabPane>
            <TabPane key='3' tab='开方设置'>
              <SquareRootSetting selectedTab={selectedTab} />
            </TabPane>
          </>}
        <TabPane key='4' tab='其他设置'>
          <OtherSettings selectedTab={selectedTab} />
        </TabPane>
      </Tabs>
    </Col>
  )
}
